import { PartnerDetails } from '@pages/partners/PartnerDetails';

export const CompanyInformation = () => {
  return <PartnerDetails />;
};
